import {
  COMMAND_ERROR,
  COMMAND_AUTH_INIT,
  COMMAND_AUTH_RESULT,
  COMMAND_CURRENT_USER_TOKEN,
  COMMAND_ACTIVATED,
  COMMAND_AUTH_DECLINED,
  COMMAND_CONNECTION_FAILED,
} from './constants';
import { QrCodeImage } from './qrcode';
import { EnfaceSocket } from './socket';
import history from '../common/history';
import { PATH_ERROR, PATH_ROOT, PATH_LOADING, PATH_LINKED } from '../common/paths';
import { sendMessageToParent } from '../common/utils';

export class EnfaceAuthWidget {
  constructor({
    debug,
    projectId,
    backendURL,
    setQrSrc,
    onSuccess,
  }) {
    this.log = debug
      ? console.log.bind(console)
      : () => {};
    this.logError = debug
      ? console.error.bind(console)
      : () => {};
    if (typeof onSuccess !== 'function') {
      console.error('[EnfaceAuthWidget] Please provide an "onSuccess" callback to process user authorization data on the client side');
      return;
    }
    if (!projectId) {
      history.push(`${PATH_ROOT}${PATH_ERROR}?type=noProjectId`);
      return;
    }
    this.projectId = projectId;
    if (!backendURL) {
      history.push(`${PATH_ROOT}${PATH_ERROR}?type=noBackendURL`);
      return;
    }
    if (!backendURL.startsWith('ws')) {
      history.push(`${PATH_ROOT}${PATH_ERROR}?type=badBackendURL`);
      return;
    }
    this.url = backendURL;
    this.setQrSrc = setQrSrc;
    this.onSuccess = onSuccess;
    this.isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent);
    window.addEventListener('message', event => {
      switch (event.data._) {
        case 'currentUserToken':
          this.log('[EnfaceAuthWidget].onMessage: "currentUserToken"', { data: event.data.token });
          // this.currentUserToken = event.data.token;
          this.send({ data: { _: COMMAND_CURRENT_USER_TOKEN, payload: event.data.token } });
          break;
        default:
          this.logError('[EnfaceId].onMessage: bad data received', { data: event.data });
          break;
      }
    }, false);
    this.init();
  }

  async init() {
    if (!this.checkEnvironment()) return;
    try {
      if (this.socket) return;
      this.log(`[EnfaceAuthWidget].init socket URL: ${this.url}`);
      this.socket = new EnfaceSocket({
        address: this.url,
        onClose: reason => {
          console.log('[EnfaceAuthWidget].init.onClose', { reason });
          this.socket = null;
          // this.cancel(reason);
        },
      });
      await this.socket.open();
      this.send({ data: { _: COMMAND_AUTH_INIT } });
    } catch (error) {
      // alert(`EnfaceAuthWidget].init [${this.url}: ${error}`);
      history.push(`${PATH_ROOT}${PATH_ERROR}?type=connection`);
    }
  }

  send({ data }) {
    return this.socket.send({
      data,
      onMessage: response => {
        this.readMessage(response);
      },
    })
      .catch(error => {
        history.push(`${PATH_ROOT}${PATH_ERROR}?type=failed`);
        this.logError('[send]', error);
        this.cancel();
      });
  }

  cancel(reason = '') {
    this.log('[EnfaceAuthWidget].cancel', { reason, 'this.socket': this.socket });
    this.socket.close();
    this.socket = null;
  }

  readMessage(data) {
    // this.log('[EnfaceAuthWidget].readMessage', data);
    this.log('[EnfaceAuthWidget].readMessage data', JSON.stringify(data, null, ' '));
    try {
      switch (data._) {
        case COMMAND_ERROR:
          history.push(`${PATH_ROOT}${PATH_ERROR}?type=failed`);
          this.logError(`Server error: ${data.message}`);
          this.cancel(data.message);
          break;
        case COMMAND_AUTH_INIT:
          this.log('[EnfaceAuthWidget] Server has initiated enable/auth chain');
          this.showQr({ t: data.token, p: data.id });
          break;
        case COMMAND_AUTH_RESULT:
          this.log('[EnfaceAuthWidget] Enface ID successfull login', { data });
          console.log({ ...data });
          if (data.error) {
            history.push(`${PATH_ROOT}${PATH_ERROR}?type=failed`);
          } else if (data.linked_id) {
            history.push(`${PATH_ROOT}${PATH_LINKED}?id=${data.linked_id}`);
          } else {
            this.onSuccess(data.token);
          }
          this.hideQr();
          break;
        case COMMAND_ACTIVATED:
          sendMessageToParent({ _: 'onGetCurrentUserToken' });
          history.push(`${PATH_ROOT}${PATH_LOADING}`);
          break;
        case COMMAND_AUTH_DECLINED:
        case COMMAND_CONNECTION_FAILED:
          history.push(`${PATH_ROOT}${PATH_ERROR}?type=${
            data._ === COMMAND_AUTH_DECLINED
              ? 'declined'
              : 'connection'
          }`);
          break;
        // case COMMAND_FAILED:
        //   history.push(`${PATH_ROOT}${PATH_ERROR}?type=failed`);
        //   this.logError('[EnfaceAuthWidget] Biometric signin failed');
        //   break;
        default:
          history.push(`${PATH_ROOT}${PATH_ERROR}?type=failed`);
          this.logError(new Error(`[EnfaceAuthWidget] Unknown command ${data._}`));
          break;
      }
    } catch (error) {
      history.push(`${PATH_ROOT}${PATH_ERROR}?type=failed`);
      this.logError(`[EnfaceAuthWidget].readMessage ${error}`);
      this.cancel(error);
    }
  }

  showQr(data) {
    data = `0:${JSON.stringify(data)}`;
    console.log('[showQr]', { data });
    this.hideQr();
    QrCodeImage(data).then(imageUrl => this.setQrSrc(imageUrl));
  }

  hideQr() {
    if (!this.qrDiv) return;
    this.qrDiv.parentNode.removeChild(this.qrDiv);
    this.qrDiv = null;
  }

  checkEnvironment() {
    if (typeof WebSocket === 'undefined') {
      console.error('This browser do not supports WebSockets. Enface authentification will not work correctly.');
      return false;
    }
    return true;
  }
}
